import { forwardRef, PropsWithoutRef } from 'react';

import { ClickAwayContextConsumer } from './ClickAwayContextConsumer';
import { ClickAwayProps } from './types';

/**
 * Be aware of WHEN you call register and deregister function !!
 * - register - should be called after overlay/dropdown menu/dialog/tooltip is opened and NOT when component is mount
 * - deregister - should be called after overlay/dropdown menu/dialog/tooltip is closed OR component will unmount
 *
 * @deprecated use useClickAway directly
 */
export function withClickAway<P, R>(Component: React.ComponentType<P & ClickAwayProps>) {
    return forwardRef((props: PropsWithoutRef<P>, ref?: React.Ref<R>) => (
        <ClickAwayContextConsumer>
            {(value) => <Component {...(props as P)} {...value} ref={ref} />}
        </ClickAwayContextConsumer>
    ));
}
